import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'

export default {
    async getCodeAndCodeCredentialStorageMax(params) {
        const response = await axios.get('certificates/credential-create/getCodesMax', {params})
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
            return data.data
        }
        return null
    },

}
